<template>
	<div>
		<el-drawer title="文档列表" :visible.sync="drawer" direction="rtl">
			<div class="file-group flex-sb wrap" v-loading="loading">
				<div class="file-item" v-for="(item,index) in list" :key="index">
					<div class="img flex-center">
						<img src="../../assets/word.png" alt=""
							v-if="['doc','docx','DOC','DOCX'].includes(getFileExtension(item.name))" />
						<img src="../../assets/pdf.png" alt=""
							v-if="['pdf','PDF'].includes(getFileExtension(item.name))" />
						<img src="../../assets/excel.png" alt=""
							v-if="['xls','xlsx','XLS','XLSX'].includes(getFileExtension(item.name))" />
						<el-image style="width: 100px; height: 100px" :src="item.download_url"
							:preview-src-list="[item.download_url]"
							v-if="['jpg','jpeg','png','webp'].includes(getFileExtension(item.name))">
						</el-image>
					</div>
					<div v-if="!['jpg','jpeg','png','webp'].includes(getFileExtension(item.name))">
						<el-dropdown placement="right" @command="handleCommand($event,item)">
							<div>
								<div class="name" @click="viewFile(item.link_url)">
									{{item.name}}
								</div>
								<div>{{renderSize(item.size)}}</div>
							</div>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item command="download">下载<span
										style="color: red;margin-left: 0.625rem;">(预览较慢时请选择下载)</span></el-dropdown-item>
								<el-dropdown-item command="view">在线预览</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</div>
					<!-- <el-card :body-style="{ padding: '0px' }">
						<img src="https://shadow.elemecdn.com/app/element/hamburger.9cf7b091-55e9-11e9-a976-7f4d0b07eef6.png"
							class="image">
						<div style="padding: 14px;">
							<span>好吃的汉堡</span>
							<div class="bottom clearfix">
								<time class="time">{{ currentDate }}</time>
								<el-button type="text" class="button">操作按钮</el-button>
							</div>
						</div>
					</el-card> -->
				</div>
			</div>
			<div class="pagination">
				<el-pagination background layout="prev, pager, next" :total="total"
					@current-change="handleCurrentChange">
				</el-pagination>
			</div>
		</el-drawer>
		<viewDoc ref="viewDoc"></viewDoc>
	</div>

</template>

<script>
	import {
		getOperatingManualTow
	} from '@/common/api/public'
	import viewDoc from '../../views/components/view-doc'
	export default {
		name: 'FilesList',
		props: {

		},
		components: {
			viewDoc
		},
		data() {
			return {
				queryForm: {
					page: 1,
					per_page: 9
				},
				list: [],
				loading: false,
				drawer: false,
				total: 0
			}
		},
		created() {},
		mounted() {

		},
		methods: {
			// 获取文件后缀
			getFileExtension(fileName) {
				return fileName.slice(fileName.lastIndexOf(".") + 1);
			},
			async getList() {
				this.loading = true
				try {
					const {
						data
					} = await getOperatingManualTow(this.queryForm)
					console.log(data)
					let arr = []
					if (data.data && data.data.length) {
						data.data.forEach((item, index) => {
							arr = arr.concat(item.files)
						})
					}
					this.list = arr;
					console.log(this.list)
					this.loading = false
					this.total = Number(data.meta.pagination.total)
				} catch (e) {
					this.loading = false
				}
			},
			async open() {
				this.drawer = true
				this.getList()
			},
			handleCurrentChange(val) {
				this.queryForm.page = val
				this.getList()
			},
			//格式化文件大小
			renderSize(value) {
				if (null == value || value == '') {
					return "0 Bytes";
				}
				var unitArr = new Array("Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB");
				var index = 0;
				var srcsize = parseFloat(value);
				index = Math.floor(Math.log(srcsize) / Math.log(1024));
				var size = srcsize / Math.pow(1024, index);
				size = size.toFixed(2);
				return size + unitArr[index];
			},
			// 操作菜单
			handleCommand(command, val) {
				if (command === 'download') {
					window.open(val.download_url, '_blank')
				} else {
					this.viewFile(val.link_url)
				}
			},
			// 在线预览
			viewFile(url) {
				window.open(url)
				return
				console.log(url)
				//你的文档地址
				var file = 'http://static.shanhuxueyuan.com/test.pdf';
				// let file = 'http://static.shanhuxueyuan.com/demo/excel.xlsx'
				// let file = 'http://static.shanhuxueyuan.com/test6.docx'
				//XDOC文档预览服务地址
				this.$refs.viewDoc.open(url, (this.authority === 'expert' ? true : false))
				return
				var xurl = "https://view.xdocin.com/view?src=";
				//传入文档地址
				// xurl += encodeURIComponent(file);
				xurl += encodeURIComponent(url);
				//预览参数
				var ops = {
					"pdf": true,
					printable: true,
				};
				if (this.authority === 'expert') {
					ops = {
						"pdf": true,
						printable: false,
						"watermark": "实验教学和教学实验室建设研究"
					}
				}
				//传入预览参数
				for (var a in ops) {
					xurl += "&" + a + "=" + encodeURIComponent(ops[a]);
				}
				//开始预览
				window.open(xurl);
				return
				let onlineViewType = ['doc', 'docx', 'xls', 'xlsx', 'xlsm', 'ppt', 'pptx']
				let fileTypeName = url.substring(url.lastIndexOf('.') + 1, url.length).split('?')[0]
				let isWord = onlineViewType.find((type) => type === fileTypeName)
				if (isWord) {
					url = 'http://view.officeapps.live.com/op/view.aspx?src=' + url
				}
				window.open(url, '_blank')
			}
		}

	}
</script>

<style lang="scss" scoped>
	.file-group {
		// width: 100%;
		flex-grow: 1;
		align-content: flex-start;

		.file-item {
			width: 30%;
			flex-grow: 0;
			padding: 10px;
			box-sizing: border-box;
			text-align: center;
			.img {
				width: 100%;

				img {
					width: 30%;
					max-height: 150px;
				}
			}

			.file-name {
				text-align: center;
				padding-top: 10px;

				.name {
					font-weight: bold;
				}

				.size {
					color: #4979ff;
					font-size: 14px;
				}
			}
		}
	}

	.pagination {
		padding: 20px;
		display: flex;
		justify-content: flex-end;
	}

	::v-deep .el-drawer__body {
		display: flex;
		flex-direction: column;
	}
</style>